

import React, { Component } from "react";
import ImageButton from "./Controls/ImageButton";
import Icon from "./Controls/Icon";
import * as actionTypes from "../../actionTypes";
import { isMobileApp } from "../../actions/Util";
import "./style.css";
import Avatar from "../Common/Avatar";
import Button from "../2/Controls/Button";
import { auth } from "../../firebase";
import Input from "./Controls/Input";
import Logo from "./Controls/Logo";
import NewButton from "./Controls/NewButton";
import ChangePassword from "../ChangePassword";
import Spinner from "../Common/Spinner";
import { adjustColorBrightness } from "../../actions/CommonAction";

// Menu theme. "light" (default) = white menu; "dark" = the original black
// menu / white-label colours. Saved per browser.
const MENU_THEME_KEY = "menuTheme";
let LIGHT_MENU = true;
// Hover / border / inactive shades are computed by lightening a dark menu;
// on a light menu the same offsets have to darken instead.
const shade = (color, amount) =>
  adjustColorBrightness(color, LIGHT_MENU ? -amount : amount);

class Menu extends Component {
  constructor() {
      
    super();
    this.drawerRef = React.createRef(); 
    this.state = {
      menus: [],
      selectedMenu: "",
      selectedSubMenu: "",
      activeMenu: null,
      showSubMenu: false,
      isDrawerVisible: false,
      showUserProfile: false,
      acceptOnlineOrdersLoading: false,
      hoveredIndex: -1,
      showMenuDrawer: false,
      showChangePassword:false,
      loading:false,
      mobileNavOpen: false
    };
    this.getVisibility = this.getVisibility.bind(this);
    this.onMenuClicked = this.onMenuClicked.bind(this);
    this.loadMenus = this.loadMenus.bind(this);
    this.showModule = this.showModule.bind(this);
    this.returnMenuItemClassName = this.returnMenuItemClassName.bind(this);
    this.onCloseMenu = this.onCloseMenu.bind(this);
    this.logout = this.logout.bind(this);
    this.handleSetActiveMenu = this.handleSetActiveMenu.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    
    this.handleLogoClick = this.handleLogoClick.bind(this);
  }

componentDidMount() {
  if (isMobileApp()) {
    this.setState({ isDrawerVisible: true }); 
  }

  LIGHT_MENU = this.isLightMenu();
  document.body.classList.toggle("menu-light", LIGHT_MENU);
  this.loadMenus(this.props.config.TransactionTypes);
  document.addEventListener("mousedown", this.handleClickOutside);
  if (this.props.history && this.props.history.listen) {
    this.unlistenHistory = this.props.history.listen(() => {
      if (this.state.mobileNavOpen) {
        this.setState({ mobileNavOpen: false });
      }
    });
  }
}
componentWillUnmount() {
  document.removeEventListener("mousedown", this.handleClickOutside);
  if (this.unlistenHistory) {
    this.unlistenHistory();
  }
}


// Phones: light unless the user picked dark, or the white-label brand has its
// own (non-black) menu colour. Web: always the original dark menu.
isLightMenu() {
  // Theme choice is a phone-only feature; the web always uses the original menu
  if (!isMobileApp()) return false;
  let pref = null;
  try { pref = window.localStorage.getItem(MENU_THEME_KEY); } catch (e) {}
  if (pref === "light") return true;
  if (pref === "dark") return false;
  const wl = (this.props.config && this.props.config.WhiteLabel) || {};
  const bg = (wl.MenuBackgroundColor || "").toLowerCase();
  return !bg || bg === "#000" || bg === "#000000" || bg === "black";
}

setMenuTheme(theme) {
  try { window.localStorage.setItem(MENU_THEME_KEY, theme); } catch (e) {}
  LIGHT_MENU = theme === "light";
  document.body.classList.toggle("menu-light", LIGHT_MENU);
  this.forceUpdate();
}

// Add these helper methods to your Menu class
getMenuBackgroundColor() {
  if (this.isLightMenu()) return '#ffffff';
  const { config } = this.props;
  if (config.WhiteLabel && config.WhiteLabel.MenuBackgroundColor) {
    return config.WhiteLabel.MenuBackgroundColor;
  }
  return '#000000'; // default black for desktop menu
}

getMenuTextColor() {
  if (this.isLightMenu()) return '#111827';
  const { config } = this.props;
  if (config.WhiteLabel && config.WhiteLabel.MenuTextColor) {
    return config.WhiteLabel.MenuTextColor;
  }
  return '#ffffff'; // default white for text
}

getSubMenuBackgroundColor() {
  if (this.isLightMenu()) return '#ffffff';
  const { config } = this.props;
  if (config.WhiteLabel && config.WhiteLabel.MenuBackgroundColor) {
    return config.WhiteLabel.MenuBackgroundColor;
  }
  return '#0D111A'; // default dark background for submenu
}

getSubMenuTextColor() {
  if (this.isLightMenu()) return '#374151';
  const { config } = this.props;
  if (config.WhiteLabel && config.WhiteLabel.MenuTextColor) {
    return config.WhiteLabel.MenuTextColor;
  }
  return '#e5e7eb'; // default light gray for submenu text
}

handleClickOutside = (event) => {
  // ignore clicks on sidebar menu
  if (event.target.closest(".main-menu")) {
    return;
  }

  if (
    this.drawerRef &&
    this.drawerRef.current &&
    !this.drawerRef.current.contains(event.target)
  ) {
      this.setState({
    showSubMenu: false,
    isDrawerVisible: false,
    showUserProfile: false
  });
  }
};

  componentDidUpdate(prevProps) {
    
    if (prevProps.user.cashRegister !== this.props.user.cashRegister) {
      console.log("cashRegister changed:", this.props.user.cashRegister);

      this.loadMenus(this.props.config.TransactionTypes);
    }

   

  // 🔁 Reload if store changed (important case)
  if (prevProps.user.store !== this.props.user.store) {
    this.loadMenus(this.props.config.TransactionTypes);
  }

  // 🔁 Reload if role/permissions change
  if (prevProps.user.user !== this.props.user.user) {
    this.loadMenus(this.props.config.TransactionTypes);
  }
   if (prevProps.user.hasAccessToMultipleStores !== this.props.user.hasAccessToMultipleStores) {
     this.loadMenus(this.props.config.TransactionTypes);
    this.renderUserStoreWidget();
  }
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.config.TransactionTypes !== this.props.config.TransactionTypes
    ) {
      this.loadMenus(nextProps.config.TransactionTypes);
    }


  }



  onOpenMenu(type) {
    this.setState({

      showSubMenu: true,
      isDrawerVisible: true,
      showUserProfile: false,
      activeMenu: { Value: type }, // optional
    });
  }


  loadMenus(transactionTypes) {
    console.log("cashRegister:", this.props.user.cashRegister);
    let menus = [];

    let salesTransactionTypes = transactionTypes.filter(
      (f) => (f.Module === "sales" && !f.IsDeleted) && !(f.hasOwnProperty("IsReturnTransaction") && f.IsReturnTransaction)
    );
    let inventoryTransactionTypes = transactionTypes.filter(
      (f) => f.Module === "inventory" && !f.IsDeleted
    );

    //sort as per sequence no
    salesTransactionTypes.sort(function (a, b) {
      let sequenceA = a.hasOwnProperty("SequenceNo") ? Number(a.SequenceNo) : 0;
      let sequenceb = b.hasOwnProperty("SequenceNo") ? Number(b.SequenceNo) : 0;
      return sequenceA - sequenceb;
    });
    inventoryTransactionTypes.sort(function (a, b) {
      let sequenceA = a.hasOwnProperty("SequenceNo") ? Number(a.SequenceNo) : 0;
      let sequenceb = b.hasOwnProperty("SequenceNo") ? Number(b.SequenceNo) : 0;
      return sequenceA - sequenceb;
    });

    if (isMobileApp()) {
      menus.push({
        Title: "Home",
        Value: "home",
        Icon: "store",
        URL: "/home",
        URLData: {},
        subMenu: []
      });
    }

    if (this.getVisibility("Sales", "read")) {
      let salesSubMenu = [];

      if (this.props.user.store.EnableTableOrder) {
        salesSubMenu.push({
          Title: "Table Order",
          Value: "tableorder",
          Icon: "new",
          URL: "/home/tableorder",
          URLData: { type: "list" }
        });
      }

      //now load sub menu
      salesTransactionTypes
        .filter((e) => {
          if (
            this.props.user.store.hasOwnProperty("EnableTableOrder") &&
            this.props.user.store.EnableTableOrder
          ) {
            return false;
          }
          let accessibleToSpecificStores = false;
          if (
            e.hasOwnProperty("AccessibleToSpecificStores") &&
            e.AccessibleToSpecificStores &&
            e.AccessibleToSpecificStoresList.filter(
              (f) => f.StoreID === this.props.user.store.key
            ).length > 0
          ) {
            accessibleToSpecificStores = true;
          } else if (
            e.hasOwnProperty("AccessibleToSpecificStores") &&
            !e.AccessibleToSpecificStores
          ) {
            accessibleToSpecificStores = true;
          } else if (!e.hasOwnProperty("AccessibleToSpecificStores")) {
            accessibleToSpecificStores = true;
          }
          if (
            e.Module === "sales" &&
            !e.IsDeleted &&
            accessibleToSpecificStores
          ) {
            return true;
          } else {
            return false;
          }
        })
        .map((i) => {
          let showModule = false;
          if (
            this.props.user.user.Role === "Power User" ||
            this.props.user.user.Role === "Store Owner" ||
            this.props.user.user.Role === "Store Manager" ||
            this.props.user.user.Role === "Store Cashier"
          ) {
            showModule = this.showModule(i.TransactionType, true);
          } else {
            if (
              this.props.user.acl.filter(
                (e) => e.id === i.TransactionType && e.perms.read
              ).length > 0
            ) {
              showModule = true;
            }
          }
          if (showModule) {
            salesSubMenu.push({
              Title: "New " + i.TransactionType,
              Value: i.TransactionType,
              Icon: "new",
              URL: "/home/sales/sales",
              URLData: { transactionType: i, type: actionTypes.SALE_NEW },
              QuickAdd: true
            });
          }
        });

      salesSubMenu.push({
        Title: "Sales History",
        Value: "saleshistory",
        Icon: "list",
        URL: "/home/sales/saleslist",
        URLData: { type: "list" }
      });

      if (
        this.props.registration &&
        this.props.registration.registration &&
        this.props.registration.registration.hasOwnProperty(
          "InventoryToSale"
        ) &&
        this.showModule("In Transit - Sales")
      ) {
        salesSubMenu.push({
          Title: "In Transit",
          Value: "intransit",
          Icon: "list",
          URL: "/home/sales/intransit",
          URLData: { type: "list" }
        });
      }

      // if (this.props.registration.registration.EnableInfinityAppOrders) {
      //   salesSubMenu.push({
      //     Title: "Online Order(s)",
      //     Value: "deliverylist",
      //     Icon: "onlineorder",
      //     URL: "/home/sales/appolineorders",
      //     URLData: { type: "list" }
      //   });
      // }

      if (this.props.registration.registration.Delivery && !isMobileApp()) {
        salesSubMenu.push({
          Title: "Delivery List",
          Value: "deliverylist",
          Icon: "list",
          URL: "/home/sales/deliverylist",
          URLData: { type: "list" }
        });
      }

      // WhatsApp orders: its own page, separate from the delivery list
      if (this.props.registration.registration.Delivery && !isMobileApp()) {
        salesSubMenu.push({
          // Title: "WhatsApp Orders",
          Title: "Online Orders",
          Value: "whatsapporders",
          Icon: "list",
          URL: "/home/sales/whatsapporders",
          URLData: { type: "list" }
        });
      }

      if (
        this.props.user.store.hasOwnProperty("CashRegisterClosing") &&
        this.showModule("CashRegistersClosing")
      ) {
        salesSubMenu.push({
          Title: "Cash Register Closing",
          Value: "cashregisterclosinglist",
          Icon: "cashregister",
          URL: "/home/sales/cashregisterclosinglist/",
          URLData: { type: "list" }
        });
      }

      if (
        this.props.registration.registration.EnablePackageTracker &&
        this.showModule("Packages")
      ) {
        salesSubMenu.push({
          Title: "Packages",
          Value: "packages",
          Icon: "packages",
          URL: "/home/packages/packagelist",
          URLData: {}
        });
      }

      if (this.props.registration.registration.KOT && !isMobileApp()) {
        salesSubMenu.push({
          Title: "KOT - Kitchen Display",
          Value: "kds",
          Icon: "kds",
          URL: "/home/KDS",
          URLData: {}
        });
        salesSubMenu.push({
          Title: "KOT - Customer Display",
          Value: "kotcustomerdisplay",
          Icon: "kds",
          URL: "/home/kotcustomerdisplay",
          URLData: {}
        });
      }

      menus.push({
        Title: "Sales",
        Value: "sales",
        Icon: "sales",
        subMenu: salesSubMenu
      });
    }


    if (this.props.user.cashRegister) {
      menus.push({
        Title: "cashregister",
        Value: "cashregister",
        Icon: "cashregister",
        subMenu: [],
        onClick: () => this.onOpenMenu("cashregister") // ✅ reusable
      });
    }

    if (this.getVisibility("Customers", "read")) {
      let crmSubMenu = [];

      if (this.getVisibility("Customers", "read")) {
        crmSubMenu.push({
          Title: "Customers",
          Value: "customers",
          Icon: "customer",
          URL: "/home/customer",
          URLData: null,
          QuickAdd: true
        });
      }
      if (this.showModule("Campaigns")) {
        crmSubMenu.push({
          Title: "Campaigns",
          Value: "campaigns",
          Icon: "campaign",
          URL: "/home/campaign",
          URLData: {}
        });
      }
      if (this.showModule("Memberships")) {
        crmSubMenu.push({
          Title: "Memberships",
          Value: "membership",
          Icon: "membership",
          URL: "/home/membership",
          URLData: {}
        });
      }
      crmSubMenu.push({
        Title: "Coupons",
        Value: "coupons",
        Icon: "coupon",
        URL: "/home/coupons",
        URLData: {}
      });

      crmSubMenu.push({
        Title: "Message Template",
        Value: "promotionalsmstemplates",
        Icon: "sms",
        URL: "/home/settings/promotionalsmstemplates/",
        URLData: {}
      });

      menus.push({
        Title: "CRM",
        Value: "crm",
        Icon: "crm",
        subMenu: crmSubMenu
      });
    }

    if (
      this.props.registration.registration.hasOwnProperty("LoyaltyEnabled") &&
      this.props.registration.registration.LoyaltyEnabled &&
      this.getVisibility("LoyaltyDashboard", "read")
    ) {
      let loyaltySubMenu = [];
      loyaltySubMenu.push({
        Title: "Loyalty Type",
        Value: "loyaltytype",
        Icon: "list",
        URL: "/home/loyalty/loyaltytype",
        URLData: null
      });
      loyaltySubMenu.push({
        Title: "Setup",
        Value: "loyaltysetup",
        Icon: "setup",
        URL: "/home/loyalty/setup",
        URLData: null
      });

      menus.push({
        Title: "Loyalty",
        Value: "loyalty",
        Icon: "loyalty",
        subMenu: loyaltySubMenu
      });
    }

    if (this.getVisibility("Inventory", "read")) {
      let inventorySubMenu = [];

      inventoryTransactionTypes
        .filter((e) => {
          let accessibleToSpecificStores = false;
          if (
            e.hasOwnProperty("AccessibleToSpecificStores") &&
            e.AccessibleToSpecificStores &&
            e.AccessibleToSpecificStoresList.filter(
              (f) => f.StoreID === this.props.user.store.key
            ).length > 0
          ) {
            accessibleToSpecificStores = true;
          } else if (
            e.hasOwnProperty("AccessibleToSpecificStores") &&
            !e.AccessibleToSpecificStores
          ) {
            accessibleToSpecificStores = true;
          } else if (!e.hasOwnProperty("AccessibleToSpecificStores")) {
            accessibleToSpecificStores = true;
          }
          if (
            e.Module === "inventory" &&
            !e.IsDeleted &&
            e.TransactionType !== "Transfer In" &&
            accessibleToSpecificStores
          ) {
            return true;
          } else {
            return false;
          }
        })
        .map((i) => {
          let showModule = false;
          if (
            this.props.user.user.Role === "Power User" ||
            this.props.user.user.Role === "Store Owner" ||
            this.props.user.user.Role === "Store Manager" ||
            this.props.user.user.Role === "Store Cashier"
          ) {
            showModule = this.showModule(i.TransactionType, true);
          } else {
            if (
              this.props.user.acl.filter(
                (e) => e.id === i.TransactionType && e.perms.read
              ).length > 0
            ) {
              showModule = true;
            }
          }

          if (showModule) {
            inventorySubMenu.push({
              Title: "New " + i.TransactionType,
              Value: i.TransactionType,
              Icon: "new",
              URL: "/home/inventory/inventory/",
              URLData: { transactionType: i, type: actionTypes.INVENTORY_NEW },
              QuickAdd: true
            });
          }
        });

      inventorySubMenu.push({
        Title: "Inventory List",
        Value: "inventorylist",
        Icon: "list",
        URL: "/home/inventory/inventorylist",
        URLData: { type: "list" }
      });
      inventorySubMenu.push({
        Title: "In Transit",
        Value: "intransit",
        Icon: "list",
        URL: "/home/inventory/intransit",
        URLData: { type: "intransit" }
      });

      if (this.showModule("Vendors", false)) {
        inventorySubMenu.push({
          Title: "Vendors",
          Value: "vendors",
          Icon: "vendors",
          URL: "/home/settings/vendors/",
          URLData: null,
          QuickAdd: true
        });
      }

      menus.push({
        Title: "Inventory",
        Value: "inventory",
        Icon: "inventory",
        subMenu: inventorySubMenu
      });
    }

    if (
      this.props.registration.registration &&
      this.props.registration.registration.EnableAppointment === true &&
      !isMobileApp()
    ) {
      menus.push({
        Title: "Appointment",
        Value: "appointment",
        Icon: "appointment",
        URL: "/home/appointment",
        URLData: null,
        subMenu: []
      });
    }

    if (this.getVisibility("Expenses", "read")) {
      let expenseSubMenu = [];

      expenseSubMenu.push({
        Title: "Expense List",
        Value: "expenselist",
        Icon: "expense",
        URL: "/home/expenselist",
        URLData: null
      });
      expenseSubMenu.push({
        Title: "Account Management",
        Value: "accountmanagement",
        Icon: "accountmanagement",
        URL: "/home/expense/transactionlist",
        URLData: null
      });

      if (this.showModule("ExpenseCategories")) {
        expenseSubMenu.push({
          Title: "Expense Categories",
          Value: "expensecategories",
          Icon: "expensecategories",
          URL: "/home/expensecategorieslist",
          URLData: null
        });
      }
      expenseSubMenu.push({
        Title: "Account",
        Value: "account",
        Icon: "account",
        URL: "/home/expense/accounts",
        URLData: null
      });

      menus.push({
        Title: "Expense",
        Value: "expense",
        Icon: "expense",
        subMenu: expenseSubMenu
      });
    }

    //staff
    if (
      this.showModule("Attendance", false) ||
      this.showModule("Employees", false)
    ) {
      let staffSubMenu = [];

      if (this.showModule("Attendance", false)) {
        staffSubMenu.push({
          Title: "Attendance",
          Value: "attendance",
          Icon: "attendance",
          URL: "/home/attendancelist",
          URLData: null
        });
      }

      if (this.showModule("Employees", false)) {
        staffSubMenu.push({
          Title: "Staff Details",
          Value: "staffdetails",
          Icon: "staff",
          URL: "/home/settings/employees/",
          URLData: null
        });
      }

      menus.push({
        Title: "Staff",
        Value: "staff",
        Icon: "staff",
        subMenu: staffSubMenu
      });
    }

    //online store
    if (
      this.props.user.store &&
      this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
      this.props.user.store.NoOfDaysToExpire > 0 &&
      this.props.user.user.Role === "Power User" &&
      !isMobileApp()
    ) {
      menus.push({
        Title: "Online Store",
        Value: "onlinestore",
        Icon: "onlinestore",
        URL: "https://posible-onlinestore-editor.web.app",
        isExternalUrl:true,
        Action: "newtab",
        subMenu: []
      });
    }

    //catalogue
    if (this.getVisibility("Products", "read")) {
      let catalogueSubMenu = [];

      if (this.showModule("Products", false)) {
        catalogueSubMenu.push({
          Title: "Product",
          Value: "product",
          Icon: "product",
          URL: "/home/product",
          URLData: null
        });
      }

      if (this.showModule("ProductCategories", false)) {
        catalogueSubMenu.push({
          Title: "Category",
          Value: "category",
          Icon: "category",
          URL: "/home/catalogue/category",
          URLData: { type: actionTypes.PRODUCT_CATEGORY }
        });
        catalogueSubMenu.push({
          Title: "Sub Category",
          Value: "subcategory",
          Icon: "subcategory",
          URL: "/home/catalogue/subcategory",
          URLData: { type: actionTypes.PRODUCT_SUB_CATEGORY }
        });
      }
      if (this.showModule("ProductBrands", false)) {
        catalogueSubMenu.push({
          Title: "Brand",
          Value: "brand",
          Icon: "brand",
          URL: "/home/catalogue/brands",
          URLData: null
        });
      }
      if (this.showModule("ProductTaxes", false)) {
        catalogueSubMenu.push({
          Title: "Taxes",
          Value: "taxes",
          Icon: "taxes",
          URL: "/home/catalogue/taxes",
          URLData: null
        });
      }
      if (this.showModule("Modifiers", false)) {
        catalogueSubMenu.push({
          Title: "Modifiers",
          Value: "modifiers",
          Icon: "modifiers",
          URL: "/home/catalogue/modifiers",
          URLData: null
        });
      }
      if (
        this.showModule("ProductTags", false) ||
        this.showModule("Offers", false)
      ) {
        catalogueSubMenu.push({
          Title: "Product Group",
          Value: "tags",
          Icon: "tags",
          URL: "/home/catalogue/tags",
          URLData: null
        });
      }
      if (this.showModule("Offers", false)) {
        catalogueSubMenu.push({
          Title: "Offers",
          Value: "offers",
          Icon: "offers",
          URL: "/home/catalogue/offer",
          URLData: null
        });
      }
      if (this.showModule("BOM", false)) {
        catalogueSubMenu.push({
          Title: "BOM",
          Value: "bom",
          Icon: "bom",
          URL: "/home/catalogue/bom",
          URLData: null
        });
      }
      if (
        this.props.user.store.hasOwnProperty("EnableFoodDeliveryPlatforms") &&
        this.props.user.store.EnableFoodDeliveryPlatforms
      ) {
        catalogueSubMenu.push({
          Title: "Aggregator Products",
          Value: "aggregatorproducts",
          Icon: "aggregatorproducts",
          URL: "/home/catalogue/fooddeliveryplatformproducts",
          URLData: null
        });
      }

      menus.push({
        Title: "Catalogue",
        Value: "catalogue",
        Icon: "catalogue",
        subMenu: catalogueSubMenu
      });
    }

    //setup
    if (this.props.user.user.Role === "Power User") {
      let setupSubMenu = [];

      if (this.showModule("Registration", false)) {
        setupSubMenu.push({
          Title: "Registration",
          Value: "registration",
          Icon: "registration",
          URL: "/home/settings/registration",
          URLData: null
        });
      }
      if (this.showModule("Stores", false)) {
        setupSubMenu.push({
          Title: "Stores",
          Value: "stores",
          Icon: "stores",
          URL: "/home/settings/stores",
          URLData: null
        });
      }
      if (this.showModule("Stores", false)) {
        setupSubMenu.push({
          Title: "Print Templates",
          Value: "printtemplates",
          Icon: "stores",
          URL: "/home/settings/printtemplates",
          URLData: null
        });
      }
      // if (this.props.config.WhiteLabel.Code === "WRX") {
        setupSubMenu.push({
          Title: "Sales Channel",
          Value: "saleschannel",
          Icon: "customfields",
          URL: "/home/settings/saleschannel",
          URLData: null
        });
      // }
      if (this.showModule("PaymentTypes", false)) {
        setupSubMenu.push({
          Title: "Payment Types",
          Value: "paymenttypes",
          Icon: "paymenttypes",
          URL: "/home/settings/paymenttypes",
          URLData: null
        });
      }
      if (
        this.props.user.store.hasOwnProperty("EnableTableOrder") &&
        this.props.user.store.EnableTableOrder
      ) {
        setupSubMenu.push({
          Title: "Tables",
          Value: "tables",
          Icon: "tables",
          URL: "/home/settings/tables",
          URLData: null
        });
      }
      if (this.showModule("CustomRoles", false)) {
        setupSubMenu.push({
          Title: "Custom Roles",
          Value: "customroles",
          Icon: "adduser",
          URL: "/home/customroles",
          URLData: null
        });
      }
      if (this.showModule("TransactionTypes", false)) {
        setupSubMenu.push({
          Title: "Module Configuration",
          Value: "moduleconfiguration",
          Icon: "moduleconfiguration",
          URL: "/home/settings/moduleconfig",
          URLData: null
        });
      }
      if (this.showModule("CustomFields", false)) {
        setupSubMenu.push({
          Title: "Custom Fields",
          Value: "customfields",
          Icon: "customfields",
          URL: "/home/settings/customfields",
          URLData: null
        });
      }
      setupSubMenu.push({
        Title: "Transactional SMS Templates",
        Value: "transactionalsmstemplates",
        Icon: "sms",
        URL: "/home/settings/transactionalsmstemplates",
        URLData: null
      });
      setupSubMenu.push({
        Title: "Additional Setting",
        Value: "addtionalsettings",
        Icon: "setup",
        URL: "/home/settings/addtionalsettings",
        URLData: null
      });
      if (this.props.registration.registration.key === "HM3hq6TxeFm38cdjcsF0") {
        setupSubMenu.push({
          Title: "On Boarding",
          Value: "onboarding",
          Icon: "customfields",
          URL: "/home/settings/onBoarding",
          URLData: null
        });
      }
        setupSubMenu.push({
        Title: "Integration",
        Value: "integration",
        Icon: "integration",
        URL: "/home/integration",
        URLData: null
      });

      menus.push({
        Title: "Setup",
        Value: "setup",
        Icon: "setup",
        subMenu: setupSubMenu
      });
    }

    if (
      this.props.user.store &&
      this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
      this.props.user.store.NoOfDaysToExpire > 0 &&
      this.props.user.user.Role !== "Store Cashier" &&
      this.getVisibility("Reports", "read")
    ) {
      let reportsSubMenu = [];

      if (this.showModule("Sales Dashboard", false)) {
        if (
          this.props.registration.registration.hasOwnProperty("NewDashboard") &&
          this.props.registration.registration.NewDashboard
        ) {
          reportsSubMenu.push({
            Title: "Dashboard",
            Value: "dashboard",
            Icon: "dashboard",
            URL: "/home/reports/dashboard",
            URLData: null
          });
        } else {
          reportsSubMenu.push({
            Title: "Dashboard",
            Value: "dashboard",
            Icon: "dashboard",
            URL: "/home",
            URLData: null
          });
        }
      }
      if (
        this.props.user.user.Role !== "Store Cashier" &&
        this.props.getVisibility("Reports", "read")
      ) {
        reportsSubMenu.push({
          Title: "Report Options",
          Value: "reportoptions",
          Icon: "reports",
          URL: "/home/reports/allreport",
          URLData: null
        });
      }

        if (
        this.props.user.user.Role !== "Store Cashier" &&
        this.props.getVisibility("Reports", "read")
      ) {
        reportsSubMenu.push({
          Title: "Downloaded Reports",
          Value: "downloadedreports",
          Icon: "download",
          URL: "/home/reports/download",
          URLData: null
        });
      }
      

      menus.push({
        Title: "Reports",
        Value: "reports",
        Icon: "reports",
        subMenu: reportsSubMenu
      });
    }

      {
      let helpDeskSubMenu = [];

      helpDeskSubMenu.push({
        Title: "Tickets",
        Value: "tickets",
        Icon: "tickets",
        URL: "/home/helpdesk/tickets",
        URLData: null
      });
     {this.props.user.user.Role == "Power User" && helpDeskSubMenu.push({
        Title: "Configuration",
        Value: "configuration",
        Icon: "setup",
        URL: "/home/helpdesk/configuration",
        URLData: null
      });}
    { this.props.user.user.Role == "Power User" && helpDeskSubMenu.push({
        Title: "Type",
        Value: "type",
        Icon: "setup",
        URL: "/home/helpdesk/type",
        URLData: null
      });}

  if ( this.props.registration.registration.hasOwnProperty(
          "EnableHelpDesk"
        )  && this.props.registration.registration.EnableHelpDesk ) {
         menus.push({
        Title: "Help Desk",
        Value: "helpdesk",
        Icon: "helpdesk",
        subMenu: helpDeskSubMenu
      });
    }


      let feedbackSubMenu = [];

      feedbackSubMenu.push({
        Title: "Feedback Templates",
        Value: "feedbacktemplates",
        Icon: "list",
        URL: "/home/feedback/template",
        URLData: null
      });
    feedbackSubMenu.push({
        Title: "Feedbacks",
        Value: "feedbacks",
        Icon: "feedback",
        URL: "/home/feedbacks",
        URLData: null
      })

  if ( this.props.registration.registration.hasOwnProperty(
          "EnableFeedback"
        )  && this.props.registration.registration.EnableFeedback ) {
         menus.push({
        Title: "Feedback",
        Value: "feedback",
        Icon: "feedback",
        subMenu: feedbackSubMenu
      });
    }
    
    }

    this.setState({ menus: menus });
  }

  getVisibility(module, access) {
    let response = this.props.getVisibility(module, access);
    if (response === "inline") {
      return true;
    } else {
      return false;
    }
  }

  showModule(module, forRole) {
    if (forRole) {
      if (
        this.props.user.user.hasOwnProperty("RoleKey") &&
        this.props.user.user.RoleKey !== ""
      ) {
        return this.props.getVisibility(module, "read");
      } else {
        return true;
      }
    } else {
      return this.getVisibility(module, "read");
    }
  }

  handleSetActiveMenu(menu) {

    if (menu.onClick) {
      menu.onClick();
      return;
    }
    // if (this.state.activeMenu && this.state.activeMenu.Value === menu.Value) {
    //   this.setState({ 
    //     showSubMenu: false,
    //     isDrawerVisible: false,
    //     activeMenu: null
    //   });
    // } else {

      if (!menu.subMenu || menu.subMenu.length === 0) {
  if (menu.URL) {
    if(menu.hasOwnProperty("isExternalUrl") && menu.isExternalUrl ){
  window.open(menu.URL, "_blank", "noopener,noreferrer");
    }else{
    this.props.history.push({
      pathname: menu.URL,
      state: menu.URLData
    });
  }
  }

  this.setState({
    activeMenu: menu,
    showSubMenu: false,
    isDrawerVisible: false
  });

  return;
}
    this.setState({
      activeMenu: menu,
      showSubMenu: true,
      isDrawerVisible: true,
      showUserProfile: false
    });
    // }
  }

  handleMouseEnter() {
    this.setState({ isDrawerVisible: true });
  }


  handleLogoClick() {
    this.props.history.push({ pathname: "/home" });
    const dashboardMenu = this.state.menus.find(function (menu) {
      return menu.subMenu && menu.subMenu.some(function (sub) {
        return sub.Title === "Dashboard";
      });
    });
    if (dashboardMenu) {
      this.setState({
        activeMenu: dashboardMenu,
        showSubMenu: false,
        isDrawerVisible: false
      });
    }
  }

  onMenuClicked(menu, index) {
    if (menu.hasOwnProperty("URL") && menu.URL !== "") {
      if (menu.hasOwnProperty("Action") && menu.Action === "newtab") {
        window.open(menu.URL, "_blank", "noopener,noreferrer");
        return;
      }
      this.props.history.push({ pathname: menu.URL, state: menu.URLData });
    }
  }

  returnMenuItemClassName(menu) {
    if (this.state.activeMenu && this.state.activeMenu.Value === menu.Value) {
      return "menu-item menu-item-selected";
    }
    return "menu-item";
  }

 renderMenuItem(menu, index, menuTextColor, inactiveTextColor) {
  const isActive = this.state.activeMenu && this.state.activeMenu.Value === menu.Value;
  
  // If colors not passed, get them
  if (!menuTextColor) menuTextColor = this.getMenuTextColor();
  if (!inactiveTextColor) inactiveTextColor = shade(menuTextColor, -40);
  const menuBgColor = this.getMenuBackgroundColor();

  return (
    <div
      key={"menuitem_" + index}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 0',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        color: isActive ? menuTextColor : inactiveTextColor,
       borderLeft: isActive
  ? `4px solid ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor}`
  : '4px solid transparent',

background: isActive
  ? `linear-gradient(to right, color-mix(in srgb, ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor} 60%, transparent), color-mix(in srgb, ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor} 10%, transparent))`
  : 'transparent',
        gap: '2px',
      }}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.color = menuTextColor;
          e.currentTarget.style.backgroundColor = shade(menuBgColor, 20);
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.color = inactiveTextColor;
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
      onClick={() => this.handleSetActiveMenu(menu)}
    >
      <span
        style={{
          width: '15px',
          height: '15px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'inherit'
        }}
      >
        <Icon type={menu.Icon} />
      </span>
      <span style={{ fontSize: '10px', textAlign: 'center', color: 'inherit' }}>
        {menu.Title}
      </span>
    </div>
  );
}
  logout() {
    this.setState({loading:true,showUserProfile:false})
    this.props.signOutUser();
    auth.signOut().then(() => {
      this.props.history.push({ pathname: "/" });
    });
      this.setState({loading:false,showUserProfile:false});
  }

onCloseMenu() {
  if (this.props.onClose) {
    this.props.onClose();
  }
  this.setState({
    showSubMenu: false,
    isDrawerVisible: false,
    showUserProfile: false
  });
}


renderUserStoreWidget() {
  const userData = this.props.user || {};
  const user = userData.user || {};
  const store = userData.store || {};
  const registration = this.props.registration.registration || {};

  return (
    <div
      style={{
     height: "100vh",
      // phones: the panel is the whole drawer; desktop sits right of the rail
      width: isMobileApp() ? "100%" : "380px",
      maxWidth: isMobileApp() ? "100%" : "calc(100vw - 72px)",
      backgroundColor: this.getSubMenuBackgroundColor(),
      color: this.getMenuTextColor(),
      display: "flex",
      flexDirection: "column",
      }}
    >
      {/* Close */}
      <div
        style={{ position: "absolute", right: "16px", top: "16px", cursor: "pointer" }}
        onClick={this.onCloseMenu}
      >
        <Icon type="remove" />
      </div>

      {/* HEADER */}
      <div style={{ position: "relative" }}>
        <div
        className="primary-gradient"
          style={{
            height: "150px",
            padding: "20px",
            paddingTop:"25px"
          }}
        >
          <div style={{ display: "flex" }}>
            {/* Avatar */}
            <div
              style={{
                width: "56px",
                height: "56px",
                background: "#EDE9FE",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "22px",
                color: "#000",
                marginRight: "12px",
              }}
            >
              {user.Name ? user.Name.charAt(0).toUpperCase() : ""}
            </div>

            {/* User Info */}
            <div style={{ flex: 1, overflow: "hidden" }}>
              <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                {user.Name}
              </div>

              <div style={{ fontSize: "13px" }}>{user.EmailID}</div>

              {/* <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "6px",
                  fontSize: "13px",
                }}
              >
                <div style={{ marginRight: "6px" }}>
                  <Icon type="store" />
                </div>
                <div
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {store.StoreName}
                </div>
              </div> */}
            </div>
          </div>
        </div>

        {/* SUBSCRIPTION CARD */}
        <div
          style={{
            position: "absolute",
            bottom: "-50px",
            left: "16px",
            right: "16px",
          }}
        >
          <div
            style={{
              background: LIGHT_MENU ? "#f9fafb" : "#1F2937",
              border: LIGHT_MENU ? "1px solid #e5e7eb" : "1px solid #374151",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            {/* Plan */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "10px",
              }}
            >
              <div>Plan</div>
              <div
                style={{
                  background: "#3B82F6",
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              >
                {registration.hasOwnProperty("Plan")
                  ? registration.Plan
                  : ""}
              </div>
            </div>

            {/* Expiry */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                // marginBottom: "10px",
              }}
            >
              <div>Expires</div>
              <div
                style={{
                  background: "#3B82F6",
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "12px",
                }}
              >
                {store.hasOwnProperty("ExpiryDate")
                  ? store.ExpiryDate
                  : store.hasOwnProperty("NoOfDaysToExpire")
                  ? store.NoOfDaysToExpire + " Days"
                  : ""}
              </div>
            </div>

            {/* <NewButton
              type="secondary"
              text="Renew"
              onClick={() => alert("Link will be provided soon")}
            /> */}
          </div>
        </div>
      </div>

      {/* CONTENT */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "16px",
          paddingTop: "60px",
        }}
      >
        {/* STORE DETAILS */}
        <div
          style={{
            background: LIGHT_MENU ? "#f9fafb" : "#1F2937",
              border: LIGHT_MENU ? "1px solid #e5e7eb" : "1px solid #374151",
            borderRadius: "8px",
            padding: "12px",
            marginBottom: "12px",
          }}
        >
          <div style={{ fontWeight: "bold" }}>
            {store.StoreCode} - {store.StoreName}
          </div>
          <div style={{ color: LIGHT_MENU ? "#6b7280" : "#9CA3AF", fontSize: "13px" }}>
            {store.Address1}
          </div>
          <div style={{ color: LIGHT_MENU ? "#6b7280" : "#9CA3AF", fontSize: "13px" }}>
            {store.Address2}
          </div>
          <div style={{ color: LIGHT_MENU ? "#6b7280" : "#9CA3AF", fontSize: "13px" }}>
            {store.City}, {store.State}
          </div>
          <div style={{ color: LIGHT_MENU ? "#6b7280" : "#9CA3AF", fontSize: "13px" }}>
            {store.Country}
          </div>
        </div>

        {/* SMS */}
        {this.props.config.WhiteLabel.Code !== "PINCODE" && (
          <div
            style={{
              background: LIGHT_MENU ? "#f9fafb" : "#1F2937",
              border: LIGHT_MENU ? "1px solid #e5e7eb" : "1px solid #374151",
              borderRadius: "8px",
              padding: "12px",
              marginBottom: "12px",
            }}
          >
            <div style={{ fontWeight: "bold", marginBottom: "6px" }}>
              SMS
            </div>

            <div style={{ fontSize: "13px", color: LIGHT_MENU ? "#6b7280" : "#9CA3AF" }}>
              Sender ID:{" "}
              {registration.hasOwnProperty("SenderID")
                ? registration.SenderID
                : "Posble"}
            </div>

            <div style={{ fontSize: "13px", color: LIGHT_MENU ? "#6b7280" : "#9CA3AF" }}>
              Transactional SMS:{" "}
              {store.hasOwnProperty("NoOfTransactionalSMS")
                ? store.NoOfTransactionalSMS
                : "Unlimited"}
            </div>

            <div style={{ fontSize: "13px", color: LIGHT_MENU ? "#6b7280" : "#9CA3AF" }}>
              Promotional SMS:{" "}
              {store.hasOwnProperty("NoOfPromotionalSMS")
                ? store.NoOfPromotionalSMS
                : 0}
            </div>
          </div>
        )}
      </div>

      {/* FOOTER */}
      <div
        style={{
          padding: "16px",
          borderTop: "1px solid " + (LIGHT_MENU ? "#e5e7eb" : "#374151"),
        }}
      >
        {/* Menu theme (phones only) */}
        {isMobileApp() && (
        <div className="menu-theme-switch" role="group" aria-label="Menu colour">
          <span className="menu-theme-switch-label">Menu</span>
          <div className="menu-theme-switch-options">
            <button
              type="button"
              className={LIGHT_MENU ? "is-selected" : ""}
              aria-pressed={LIGHT_MENU}
              onClick={() => this.setMenuTheme("light")}
            >
              Light
            </button>
            <button
              type="button"
              className={!LIGHT_MENU ? "is-selected" : ""}
              aria-pressed={!LIGHT_MENU}
              onClick={() => this.setMenuTheme("dark")}
            >
              Dark
            </button>
          </div>
        </div>
        )}
        {this.props.config.UserStores.length > 1 && (
          <div style={{ marginBottom: "8px" ,color:"black"}}>
            <NewButton
              type="secondary"
              text="Change Store"
              onClick={() => {
                this.onCloseMenu();
                this.props.onStoreChangeResetConfig();
                this.props.onStoreChangeResetUser();
                this.props.history.push("/home");
              }}
            />
          </div>
        )}

        <div style={{ marginBottom: "8px",color:"black" }}>
          <NewButton
            type="secondary"
            text="Change Password"
            onClick={() => {
              this.setState({ showChangePassword: true });
              this.onCloseMenu();
            }}
          />
        </div>

        <div style={{ marginBottom: "8px" ,color:"black"}}>
          <NewButton
            type="secondary"
            text="Sign Out"
            onClick={this.logout}
          />
        </div>

        <div
          style={{
            textAlign: "center",
            fontSize: "12px",
            color: "#9CA3AF",
            marginTop: "10px",
          }}
        >
          Version: {this.props.config.Version}
        </div>
      </div>
    </div>
  );
}


renderSubMenuDrawer() {
  const { activeMenu, isDrawerVisible, showSubMenu, hoveredIndex } = this.state;
  const subMenuBgColor = this.getSubMenuBackgroundColor();
  const subMenuTextColor = this.getSubMenuTextColor();

  if (this.state.showUserProfile) {
    return (
      <div
        ref={this.drawerRef}
        className="menu-submenu-drawer"
        style={{
          position: 'fixed',
          top: 0,
          left: '72px',
          width: '260px',
          height: '100vh',
          backgroundColor: subMenuBgColor,
          zIndex: 999,
          transform: this.state.isDrawerVisible ? 'translateX(0)' : 'translateX(-100%)',
          opacity: this.state.isDrawerVisible ? 1 : 0,
          transition: 'all 0.3s ease'
        }}
      >
        {this.renderUserStoreWidget()}
      </div>
    );
  }

  if (!activeMenu || !showSubMenu) return null;

  if (activeMenu.Value === "cashregister") {
    return (
      <div 
        ref={this.drawerRef}
        className="menu-submenu-drawer"
        style={{
          position: 'fixed',
          top: 0,
          left: '72px',
          width: '260px',
          height: '100vh',
          backgroundColor: subMenuBgColor,
          zIndex: 999,
          transform: isDrawerVisible ? 'translateX(0)' : 'translateX(-100%)',
          opacity: isDrawerVisible ? 1 : 0,
          transition: 'all 0.3s ease'
        }}>
        {this.renderCashRegisterWidget()}
      </div>
    );
  }

  return (
    <div
      ref={this.drawerRef}
        className="menu-submenu-drawer"
      style={{
        position: 'fixed',
        top: 0,
        left: '72px',
        width: '260px',
        height: '100vh',
        backgroundColor: subMenuBgColor,
        boxShadow: '2px 0 8px rgba(0,0,0,0.15)',
        zIndex: 999,
        transform: isDrawerVisible ? 'translateX(0)' : 'translateX(-100%)',
        opacity: isDrawerVisible ? 1 : 0,
        transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
        overflowY: 'auto'
      }}
      onMouseEnter={this.handleMouseEnter}
    >
      {/* HEADER */}
      <div
        style={{
          padding: '10px 12px',
          backgroundColor: subMenuBgColor
        }}
      >
        {/* Close button */}
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <button
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: subMenuTextColor,
              padding: '4px',
              borderRadius: '4px',
              transition: 'all 0.2s ease'
            }}
            onClick={() => {
              this.onCloseMenu();
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = this.props.config.WhiteLabel.PrimaryColor || shade(subMenuTextColor, 30);
              e.currentTarget.style.backgroundColor = shade(subMenuBgColor, 30);
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = subMenuTextColor;
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            <Icon type="remove" />
          </button>
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: '14px',
            fontWeight: 600,
            margin: '6px 0 0 0',
            color: subMenuTextColor,
            textTransform: 'capitalize'
          }}
        >
          {activeMenu.Title}
        </h1>
      </div>

      {/* SUB MENU */}
      <div
        style={{
          padding: '8px 0',
          marginTop: '20px',
          borderTop: '2px solid',
          borderImage: `linear-gradient(to right, ${shade(subMenuTextColor, 30)}66, ${shade(subMenuTextColor, 20)}1A) 1`
        }}
      >
        {activeMenu.subMenu &&
          activeMenu.subMenu.map((subMenu, idx) => {
            // Calculate hover background color - make it more visible
            const hoverBgColor = `${this.props.config.WhiteLabel.ActiveSubMenuBackgroundColor}`
            
            return (
              <div
                key={idx}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px 16px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  gap: '12px',
                  color: subMenuTextColor,
                  borderRadius: '0px',
                  margin: '2px 0',
                  backgroundColor: hoveredIndex === idx ? hoverBgColor : 'transparent'
                }}
                onMouseEnter={() => this.setState({ hoveredIndex: idx })}
                onMouseLeave={() => this.setState({ hoveredIndex: null })}
                onClick={() => {
                  if (subMenu && subMenu.URL) {
                    if (subMenu.Action === "newtab") {
                      window.open(subMenu.URL, "_blank", "noopener,noreferrer");
                    } else {
                      this.props.history.push({
                        pathname: subMenu.URL,
                        state: subMenu.URLData || undefined
                      });
                    }
                    this.onCloseMenu();
                  }
                }}
              >
                {/* ICON */}
                {subMenu.Icon && (
                  <span
                    style={{
                      width: '18px',
                      height: '18px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0.8,
                      color:subMenuTextColor
                    }}
                  >
                    <Icon type={subMenu.Icon} />
                  </span>
                )}

                {/* TITLE */}
                <span style={{ 
                  flex: 1, 
                  fontSize: '13px',
                  fontWeight: hoveredIndex === idx ? 500 : 400
                }}>
                  {subMenu.Title}
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );
}
 

renderCashRegisterWidget() {
    return (
      <div className="menu-user">
        <div className="menu-user-content">
          <Avatar text={this.props.user.cashRegister.CashRegisterName} />
          <div>
           <div style={{ color:this.getMenuTextColor() }}>
              {this.props.user.cashRegister.CashRegisterCode}-
              {this.props.user.cashRegister.CashRegisterName}
            </div>
          </div>
        </div>
        <br />
        {this.props.user.cashRegisterClosing && (
          <React.Fragment>
            <div className="info">
              <div className="info-header">Cash Register Closing </div>
              <div className="info-text"></div>
              <div className="info-text">
                Opening Balance:{" "}
                {this.props.user.cashRegisterClosing.OpeningBalance}
              </div>
              <div className="info-text">
                Opening Time:{" "}
                {new Date(
                  this.props.user.cashRegisterClosing.OpeningTime._seconds * 1000
                )
                  .toString()
                  .substring(0, 24)}
              </div>
              <div className="v">
                Opening By:{" "}
                {this.props.user.cashRegisterClosing.OpeningByUserName}
              </div>
            </div>
            <NewButton
              type="secondary"
              text="Close Cash Register"
              onClick={() => {
              this.onCloseMenu();
                this.props.history.push({
                  pathname: "/home/sales/cashregisterclosing/",
                  state: {
                    cashRegisterClosing: this.props.user.cashRegisterClosing,
                  },
                });
              }}
            />
          </React.Fragment>
        )}
        {/* <NewButton
          type="secondary"
          text="Setup"
          onClick={() => {
              this.onCloseMenu();
            this.props.history.push("/home/settings/cashregister/setup/");
          }}
        /> */}
      </div>
    );
  }

renderMobileMenu() {
  const isExpired = this.props.user.store &&
    this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
    this.props.user.store.NoOfDaysToExpire <= 0;

  const setupMenu = this.state.menus.find(function (menu) {
    return menu.Title === "Setup";
  });

  const isSetupActive = this.state.activeMenu && this.state.activeMenu.Title === "Setup";
  
  const menuBgColor = this.getMenuBackgroundColor();
  const menuTextColor = this.getMenuTextColor();
  const subMenuBgColor = this.getSubMenuBackgroundColor();
  const subMenuTextColor = this.getSubMenuTextColor();

  const menuItems = this.state.menus.filter(function(menu) {
    return menu.Title !== "Setup";
  });

  return (
    <div style={{ position: 'relative' }} className="no-print">
      {/* Overlay */}
      {(this.state.isDrawerVisible || this.state.showUserProfile) && (
        <div
          onClick={() =>
            this.setState({
              showSubMenu: false,
              isDrawerVisible: false,
              showUserProfile: false,
              activeMenu: null
            })
          }
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
            zIndex: 998
          }}
        />
      )}

      {/* Main Mobile Drawer - Hidden when showing user profile */}
      {!this.state.showUserProfile && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            height: '100vh',
            backgroundColor: menuBgColor,
            color: menuTextColor,
            zIndex: 999,
            width: '80%',
            transform: this.state.isDrawerVisible ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.3s ease-in-out',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          {/* Header */}
          <div
            style={{
              padding: '16px',
              borderBottom: `1px solid ${shade(menuTextColor, -60)}`,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
<span className="mobile-menu-logo">
            <Logo
              logoOption={this.props.config.WhiteLabel.MobileMenuLogoOption}
              height="40px"
              onClick={() => {
                this.props.history.push({ pathname: "/home" });
                this.onCloseMenu();
              }}
            />
            </span>
            <button
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                color: menuTextColor,
                width: '28px',
                height: '28px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              onClick={this.onCloseMenu}
            >
              <Icon type="remove" />
            </button>
          </div>

          {/* Content */}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              paddingBottom: '80px'
            }}
          >
            {/* Main menu items - rest of your existing menu code */}
            {!isExpired &&
              menuItems.map(function(menu, index) {
                const hasSubMenu = menu.subMenu && menu.subMenu.length > 0;
                
                return (
                <div
                  key={"mobile_menu_" + index}
                  style={{
                    borderBottom: `1px solid ${shade(menuTextColor, -60)}`
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      padding: '16px',
                      cursor: 'pointer',
                      backgroundColor: this.state.activeMenu && this.state.activeMenu.Value === menu.Value ? subMenuBgColor : 'transparent',
                      transition: 'background-color 0.2s'
                    }}
                    onClick={() => {
                      // If menu has no submenu or has only 1 submenu item, handle navigation directly
                      if (!hasSubMenu) {
                        // Direct navigation for menu items without submenu
                        if (menu.URL) {
                          if (menu.Action === "newtab") {
                            window.open(menu.URL, "_blank", "noopener,noreferrer");
                          } else {
                            this.props.history.push({
                              pathname: menu.URL,
                              state: menu.URLData || undefined
                            });
                          }
                          this.onCloseMenu();
                        } else {
                          // If no URL, just handle as regular menu toggle
                          this.handleSetActiveMenu(menu);
                        this.onCloseMenu();
                        }
                      } else {
                           if (this.state.activeMenu && this.state.activeMenu.Value === menu.Value) {
      // Menu is already open - close it
      this.setState({ activeMenu: null });
    } else {
      // Menu is closed - open it
      this.handleSetActiveMenu(menu);
    }
                      }
                      
                    
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <span style={{ marginRight: '12px', width: '20px' }}>
                        <Icon type={menu.Icon} />
                      </span>
                      <span style={{ textTransform: 'capitalize' }}>{menu.Title}</span>
                    </div>
                    {/* Only show arrow if menu has submenu items */}
                    {hasSubMenu && (
                      <svg
                        style={{
                          width: '16px',
                          height: '16px',
                          transition: 'transform 0.2s',
                          transform: this.state.activeMenu && this.state.activeMenu.Value === menu.Value ? 'rotate(90deg)' : 'rotate(0deg)'
                        }}
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    )}
                  </div>

                  {/* Submenu - only show if menu has submenu items AND is active */}
                  {hasSubMenu && this.state.activeMenu && this.state.activeMenu.Value === menu.Value && (
                    <div style={{ backgroundColor: subMenuBgColor, padding: '8px' }}>
                      {menu.subMenu.map(function(subMenu, subIndex) {
                        return (
                        <div
                          key={"submenu_" + subIndex}
                          style={{
                            padding: '12px',
                            cursor: 'pointer',
                            borderRadius: '4px',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = shade(subMenuBgColor, 20);
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                          }}
                          onClick={() => {
                            if (subMenu && subMenu.hasOwnProperty("URL")) {
                              if (subMenu.hasOwnProperty("Action") && subMenu.Action === "newtab") {
                                window.open(subMenu.URL, "_blank", "noopener,noreferrer");
                              } else {
                                this.props.history.push({
                                  pathname: subMenu.URL,
                                  state: subMenu.hasOwnProperty("URLData") ? subMenu.URLData || undefined : undefined
                                });
                              }
                              this.onCloseMenu();
                            }
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            {subMenu.hasOwnProperty("Icon") && subMenu.Icon && (
                              <span style={{ marginRight: '12px', width: '20px' }}>
                                <Icon type={subMenu.Icon} />
                              </span>
                            )}
                            <span style={{ fontSize: '14px' }}>{subMenu.Title}</span>
                          </div>
                        </div>
                        );
                      }.bind(this))}
                    </div>
                  )}
                </div>
                );
              }.bind(this))}

            {/* Setup menu */}
            {setupMenu && !isExpired && (
              <div style={{ borderBottom: `1px solid ${shade(menuTextColor, -60)}` }}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '16px',
                    cursor: 'pointer',
                    backgroundColor: this.state.activeMenu && this.state.activeMenu.Value === setupMenu.Value ? subMenuBgColor : 'transparent',
                    transition: 'background-color 0.2s'
                  }}
                  onClick={() => {
                    const hasSubMenu = setupMenu.subMenu && setupMenu.subMenu.length > 0;
                    
                    // If Setup menu has no submenu or has only 1 submenu item, handle navigation directly
                    if (!hasSubMenu) {
                      if (setupMenu.URL) {
                        if (setupMenu.Action === "newtab") {
                          window.open(setupMenu.URL, "_blank", "noopener,noreferrer");
                        } else {
                          this.props.history.push({
                            pathname: setupMenu.URL,
                            state: setupMenu.URLData || undefined
                          });
                        }
                        this.onCloseMenu();
                      } else {
                        this.handleSetActiveMenu(setupMenu);
                         if (this.props.onClose) {
                      this.props.onClose();
                    }
                      }
                    } else {
                          if (this.state.activeMenu && this.state.activeMenu.Value === setupMenu.Value) {
      // Menu is already open - close it
      this.setState({ activeMenu: null });
    } else {
      // Menu is closed - open it
      this.handleSetActiveMenu(setupMenu);
    }
                    }
                    
                   
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginRight: '12px', width: '20px' }}>
                      <Icon type="setup" />
                    </span>
                    <span style={{ textTransform: 'capitalize' }}>Setup</span>
                  </div>
                  {/* Only show arrow if Setup has submenu items */}
                  {setupMenu.subMenu && setupMenu.subMenu.length > 0 && (
                    <svg
                      style={{
                        width: '16px',
                        height: '16px',
                        transition: 'transform 0.2s',
                        transform: this.state.activeMenu && this.state.activeMenu.Value === setupMenu.Value ? 'rotate(90deg)' : 'rotate(0deg)'
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  )}
                </div>

                {/* Setup Submenu - only show if Setup has submenu items AND is active */}
                {setupMenu.subMenu && setupMenu.subMenu.length > 0 && 
                 this.state.activeMenu && this.state.activeMenu.Value === setupMenu.Value && (
                  <div style={{ backgroundColor: subMenuBgColor, padding: '8px' }}>
                    {setupMenu.subMenu.map(function(subMenu, subIndex) {
                      return (
                      <div
                        key={"setup_submenu_" + subIndex}
                        style={{
                          padding: '12px',
                          cursor: 'pointer',
                          borderRadius: '4px',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = shade(subMenuBgColor, 20);
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        onClick={() => {
                          if (subMenu && subMenu.hasOwnProperty("URL")) {
                            this.props.history.push({
                              pathname: subMenu.URL,
                              state: subMenu.hasOwnProperty("URLData") ? subMenu.URLData || undefined : undefined
                            });
                            this.onCloseMenu();
                          }
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {subMenu.hasOwnProperty("Icon") && subMenu.Icon && (
                            <span style={{ marginRight: '12px', width: '20px' }}>
                              <Icon type={subMenu.Icon} />
                            </span>
                          )}
                          <span style={{ fontSize: '14px' }}>{subMenu.Title}</span>
                        </div>
                      </div>
                      );
                    }.bind(this))}
                  </div>
                )}
              </div>
            )}

            {/* User Profile Button */}
            <div style={{ padding: '16px', borderTop: `1px solid ${shade(menuTextColor, -60)}`, marginTop: 'auto' }}>
              <div
                onClick={() => {
                  this.setState({
                    showUserProfile: true,
                    showSubMenu: false,
                    activeMenu: null,
                    isDrawerVisible: true
                  });
                }}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '12px',
                  borderRadius: '8px',
                  backgroundColor: subMenuBgColor,
                  cursor: 'pointer',
                  transition: 'background-color 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = shade(subMenuBgColor, 20);
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = subMenuBgColor;
                }}
              >
                <span style={{ marginRight: '12px', width: '20px' }}>
                  <Icon type="user" />
                </span>
                <span>User Profile</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* User Profile Drawer - Now FULL WIDTH with its own close button */}
{this.state.showUserProfile && (
  <div
    style={{
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      backgroundColor: menuBgColor,
      color: menuTextColor,
      zIndex: 1000,
      width: '100%',
      transform: 'translateX(0)',
      transition: 'transform 0.3s ease-in-out',
      overflowY: 'auto'
    }}
  >
    <div
      style={{
        padding: '12px 16px',
        borderBottom: `1px solid ${shade(menuTextColor, -60)}`,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        backgroundColor: menuBgColor,
        zIndex: 1001
      }}
    >
      <button
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: menuTextColor,
          width: '32px',
          height: '32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          borderRadius: '4px',
          transition: 'background-color 0.2s',
          padding: 0,
          margin: 0
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = shade(menuTextColor, -80);
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
        onClick={() => {
          this.setState({ 
            showUserProfile: false, 
            isDrawerVisible: false 
          });
          this.onCloseMenu();
        }}
      >
        <Icon type="remove" />
      </button>
    </div>
    <div>
      {this.renderUserStoreWidget()}
    </div>
  </div>
)}
    </div>
  );
}
renderDesktopMenu() {
  const isExpired = this.props.user.store &&
    this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
    this.props.user.store.NoOfDaysToExpire <= 0;

  const setupMenu = this.state.menus.find(function (menu) {
    return menu.Title === "Setup";
  });

  const isSetupActive = this.state.activeMenu && this.state.activeMenu.Title === "Setup";
  
  const menuBgColor = this.getMenuBackgroundColor();
  const menuTextColor = this.getMenuTextColor();
  const inactiveTextColor = shade(menuTextColor, -40); // darker version for inactive

  return (
    <div style={{ position: 'relative', display: 'flex' }} className="no-print">
      {/* Below 768px the rail is off-canvas; these two are hidden by CSS on larger screens */}
      <button
        type="button"
        className="mobile-nav-toggle"
        aria-label="Open menu"
        onClick={() => this.setState({ mobileNavOpen: true })}
      >
        <i className="fa fa-bars"></i>
      </button>
      {this.state.mobileNavOpen && (
        <div
          className="mobile-nav-backdrop"
          onClick={() =>
            this.setState({
              mobileNavOpen: false,
              showSubMenu: false,
              isDrawerVisible: false,
              showUserProfile: false
            })
          }
        />
      )}
      {/* Main Menu - Width 72px, Dynamic Background */}
      <div className={"main-menu" + (this.state.mobileNavOpen ? " main-menu--open" : "")} style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '72px',
        height: '100vh',
        backgroundColor: menuBgColor,
        borderRight: LIGHT_MENU ? '1px solid #e5e7eb' : 'none',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 100,
        overflowY: 'auto',
        overflowX: 'hidden'
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '8px 0',
          cursor: 'pointer',
          transition: 'transform 0.3s ease'
        }}
          onClick={this.handleLogoClick}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
        >
          <Logo
            logoOption={this.props.config.WhiteLabel.DesktopMenuLogoOption}
            height="30px"
            onClick={this.handleLogoClick}
          />
        </div>

        {/* Menu Items */}
        {!isExpired && (
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '' }}>
            {this.state.menus
              .filter(function (menu) {
                return menu.Title !== "Setup";
              })
              .map(function (menu, index) {
                return this.renderMenuItem(menu, index, menuTextColor, inactiveTextColor);
              }.bind(this))}
          </div>
        )}

        {/* Setup Menu at Bottom */}
        {setupMenu && !isExpired && (
          <div style={{ padding: '0 0' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px 0',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                color: isSetupActive ? menuTextColor : inactiveTextColor,
                borderLeft: isSetupActive ? `4px solid ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor}` : '4px solid transparent',
                background: isSetupActive
                  ? `linear-gradient(to right, color-mix(in srgb, ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor} 60%, transparent), color-mix(in srgb, ${this.props.config.WhiteLabel.ActiveMenuBackgroundColor} 10%, transparent))`
                  : 'transparent',
                gap: '2px'
              }}
              onMouseEnter={(e) => {
                if (!isSetupActive) {
                  e.currentTarget.style.color = menuTextColor;
                  e.currentTarget.style.backgroundColor = shade(menuBgColor, 20);
                }
              }}
              onMouseLeave={(e) => {
                if (!isSetupActive) {
                  e.currentTarget.style.color = inactiveTextColor;
                  e.currentTarget.style.backgroundColor = 'transparent';
                }
              }}
              onClick={() => this.handleSetActiveMenu(setupMenu)}
            >
              <span style={{ width: '15px', height: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Icon type="setup" />
              </span>
              <span style={{ fontSize: '10px', textAlign: 'center' }}>Setup</span>
            </div>
          </div>
        )}

        {/* User Profile Icon */}
        <div style={{ padding: '0px 0', display: 'flex', justifyContent: 'center' }}>
          <div
            onClick={(e) => {
              e.stopPropagation();
              this.setState({
                showUserProfile: !this.state.showUserProfile,
                showSubMenu: false,
                activeMenu: null,
                isDrawerVisible: true
              });
            }}
            style={{
              borderRadius: '50%',
              cursor: 'pointer',
              backgroundColor: this.state.showUserProfile ? this.props.config.WhiteLabel.PrimaryColor : menuTextColor,
              color: this.state.showUserProfile ? menuTextColor : menuBgColor,
              padding: '8px',
              width: '36px',
              height: '36px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s ease',
              margin: "8px 0"
            }}
          >
            <Icon type="user" />
          </div>
        </div>
      </div>

      {/* Submenu Drawer with Animation */}
      {(this.state.isDrawerVisible || this.state.showUserProfile) && (
        <div
          onClick={() =>
            this.setState({
              showSubMenu: false,
              isDrawerVisible: false,
              showUserProfile: false
            })
          }
          style={{
            position: "fixed",
            top: 0,
            left: 72,
            width: "calc(100% - 72px)",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.4)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)",
            zIndex: 998
          }}
        />
      )}
      {this.renderSubMenuDrawer()}
    </div>
  );
}

render() {
  LIGHT_MENU = this.isLightMenu();
  const isExpired = this.props.user.store &&
    this.props.user.store.hasOwnProperty("NoOfDaysToExpire") &&
    this.props.user.store.NoOfDaysToExpire <= 0;

  const setupMenu = this.state.menus.find(function (menu) {
    return menu.Title === "Setup";
  });

  const isSetupActive = this.state.activeMenu && this.state.activeMenu.Title === "Setup";

  if(this.state.loading){
    return <Spinner/>
  }
  if (isMobileApp()) {
    return (
      <>
        {this.renderMobileMenu()}
        {this.state.showChangePassword && (
          <ChangePassword
            onClose={() => this.setState({ showChangePassword: false })}
            {...this.props}
          />
        )}
      </>
    );
  }

  return (
    <>
      {this.renderDesktopMenu()}
      {this.state.showChangePassword && (
        <ChangePassword
          onClose={() => this.setState({ showChangePassword: false })}
          {...this.props}
        />
      )}
    </>
  );
}
}

export default Menu;